import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "UnscheduledVisitModal",
  components: { customModal },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: "",
      head: {},
      subId :"",
      visitData: {
        studyId: "",
        studyVersion: "",
        patientId: "",
        visitNo: "",
        visitName: "",
        visitType: "",
        visitDate: new Date().toISOString().substring(0, 10),
        preVisit: "",
        postVisit: "",
        investigator: "",
        active: true,
        isPatientVisit: false,
        scheduleofActivity: [{ activityId: "", activityName: "", activityOrder: 0 }],
        related: "",
        relationType: "After",
        visitNote: ""
      },
      visitTypes: [],
      users: [],
      activityOptions: [],
      activityList: [],
      activityCount: 0,
      editingIndex: null,
      editedActivity: { activityId: "", activityOrder: 0 },
      currentPage: 1,
      totalPage: 1,
      errors: [false, false, false, false],
      numerrors: { preVisit: true, postVisit: true },
      validations: [false, false],
      activityForm: { selectedActivityId: "", order: "" },
    };
  },
  props: {
    patientId: String,
    relatedId: String
  },
  computed: {
    activityOrderOptions() {
      return () => Array.from({ length: this.activityList.length + 1 }, (_, i) => i + 1);
    },
  },

  async mounted() {
    this.subId = this.patientId;
    this.idToken = store.getters.getIdToken;
    this.visitData.related = this.relatedId;
    this.head = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    await this.getVisitType();
    await this.getUsers();
    await this.fetchActivityOptions();
  },

  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    async getVisitType() {
      try {
        const res = await axios.get(`${this.baseurl}/management/visittype/listvisittypes`, this.head);
        this.visitTypes = res.data.entities;
      } catch (err) {
        console.error(err);
      }
    },

    async getUsers() {
      try {
        const studyId = store.getters.getStudyIs;
        const res = await axios.get(
          `${this.baseurl}/management/study/getusersinstudy?StudyId=${studyId}`,
          this.head
        );
        this.users = res.data;
      } catch (err) {
        console.error(err);
      }
    },

    async fetchActivityOptions() {
      const StudyId = store.getters.getStudyIs;
      const studyVersion = localStorage.getItem("selectedsetlatestversion");
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/listsoa?studyId=${StudyId}&studyVersion=${studyVersion}&activityType=&pageindex=1&pagesize=100`,
          this.head
        );
        this.activityOptions = res.data.entities;
      } catch (err) {
        console.error("Error loading activity options", err);
      }
    },

    numberonlyvalidation(fieldname) {
      const val = this.visitData[fieldname];
      if (val !== "" && val !== null && val !== undefined) {
        if (!Number.isInteger(Number(val)) || Number(val) < 0) {
          this.visitData[fieldname] = "";
          this.numerrors[fieldname] = false;
        } else {
          this.numerrors[fieldname] = true;
        }
      }
    },

    async validateVisitData() {
        this.errors = [false, false, false, false, false];

        const fields = [
            { val: this.visitData.visitNo, index: 0 },
            { val: this.visitData.visitName, index: 1 },
            { val: this.visitData.visitType, index: 2 },
            { val: this.visitData.visitDate, index: 3 },
        ];

        let valid = true;

        fields.forEach(({ val, index }) => {
            if (!val || val.trim() === "") {
            this.errors[index] = true;
            valid = false;
            }
        });

        if (
            this.activityList.length === 0 ||
            this.activityList.some(
            (a) => !a.activityName || a.activityName.trim() === ""
            )
        ) {
            this.errors[4] = true;
            valid = false;
        }

        return valid;
    },
    async addUnscheduledVisit() {
      const isValid = await this.validateVisitData();
      if (!isValid) return;
      console.log("Saving visit:", this.visitData);
      await this.saveUnscheduledvisit();
    },
    async saveUnscheduledvisit() {
        this.visitData.studyId = store.getters.getStudyIs;
        this.visitData.studyVersion = localStorage.getItem("selectedsetlatestversion");
        this.visitData.patientId = this.subId;

        this.visitData.scheduleofActivity = this.activityList.map((x) => ({
            activityId: x.activityId,
            activityName: x.activityName,
            activityOrder: x.activityOrder,
        }));

        await axios
            .post(
            `${this.baseurl}/management/patientschedule/unscheduledvisit`,
            this.visitData,
            this.head
            )
            .then((res) => {
            if (res.status === 200 || res.status === 201) {
                alert(this.$t("navigations.unscheduled visit added successfully"));
                this.closeModal();
                this.modalSchedule = false;
            } else if (res.data?.messages?.[0]?.includes("Visit Number already exists")) {
                alert(this.$t("navigations.visit number already exists"));
            } else {
                alert(this.$t("navigations.error occurred while saving visit"));
            }
            })
            .catch((err) => {
            if (err.response?.data?.messages?.[0]?.includes("Visit Number already exists")) {
                alert(this.$t("navigations.visit number already exists"));
            } else {
                alert(this.$t("navigations.error occurred while saving visit"));
            }
            });
    },
    addActivity() {
        this.validations = [false, false];

        const selectedId = this.activityForm.selectedActivityId;
        const selectedOrder = this.activityForm.order;

        // Validate activity ID and order
        if (!selectedId || selectedId.trim() === "") this.validations[0] = true;
        if (!selectedOrder) this.validations[1] = true;

        // Get selected activity
        const activity = this.activityOptions.find((a) => a.id === selectedId);

        // ✅ Null validation for activity name
        if (!activity || !activity.activityName || activity.activityName.trim() === "") {
            this.validations[0] = true;
        }

        // Stop if any validation failed
        if (this.validations.includes(true)) return;

        const existingOrderIndex = this.activityList.findIndex(
            (a) => a.activityOrder === parseInt(selectedOrder)
        );

        const newActivity = {
            activityId: selectedId,
            activityName: activity.activityName,
            activityOrder: parseInt(selectedOrder),
            status: "Pending",
        };

        if (existingOrderIndex !== -1) {
            if (
            confirm(
                this.$t(
                "navigations.activity order already exist do you want to replace existing order"
                )
            )
            ) {
            this.activityList.forEach((item) => {
                if (item.activityOrder >= parseInt(selectedOrder)) {
                item.activityOrder += 1;
                }
            });
            this.activityList.push(newActivity);
            this.activityList.sort((a, b) => a.activityOrder - b.activityOrder);
            } else {
            return;
            }
        } else {
            this.activityList.push(newActivity);
        }

        this.activityCount = this.activityList.length;
        this.activityForm = { selectedActivityId: "", order: "" };
    },
    editActivity(index) {
      this.editingIndex = index;
      this.editedActivity = { ...this.activityList[index] };
    },
    saveEditedActivity(index) {
      this.activityList.splice(index, 1, this.editedActivity);
      this.editingIndex = null;
    },

    cancelEdit() {
      this.editingIndex = null;
    },

    removeActivity(index) {
      this.activityList.splice(index, 1);
      this.activityCount = this.activityList.length;
    },

    openFormsModal(item) {
      console.log("Open forms modal for:", item);
    },
  },
};
